import { render, staticRenderFns } from "./OverPayment.vue?vue&type=template&id=b99c02ca&lang=pug"
import script from "./OverPayment.vue?vue&type=script&lang=js"
export * from "./OverPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports